import {
  AGENT,
  INFORMATION_AGENT,
  PLAN_ADMINISTRATOR,
} from "../../../../../utils/Roles";

export const GENERAL_INFORMATION = {
  value: "GENERAL_INFORMATION",
  name: "clients.form.sections.generalInformation",
  requiredRole: [INFORMATION_AGENT, PLAN_ADMINISTRATOR],
};

export const ACCOUNTING = {
  value: "ACCOUNTING",
  name: "clients.form.sections.accounting",
  requiredRole: AGENT,
};

export const CONFIGURATION = {
  value: "CONFIGURATION",
  name: "clients.form.sections.configuration",
  requiredRole: AGENT,
};

export const ASSOCIATED_BROKERS = {
  value: "ASSOCIATED_BROKERS",
  name: "clients.form.sections.associatedBrokers",
  requiredRole: AGENT,
};

export const COVERAGE_PERIODS = {
  value: "COVERAGE_PERIODS",
  name: "clients.form.sections.coveragePeriods",
  requiredRole: AGENT,
};

export default {
  GENERAL_INFORMATION,
  ACCOUNTING,
  CONFIGURATION,
  ASSOCIATED_BROKERS,
  COVERAGE_PERIODS
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client-form/basic-client-sections/clientSectionEnum.js